import { Link } from '@chakra-ui/react';

export function quickCashflowDriveExportSuccessToast({ folderName, folderUrl }) {
  return {
    title: `Saved to Drive — ${folderName}`,
    description: (
      <Link
        href={folderUrl}
        isExternal
        color="white"
        fontWeight="semibold"
        textDecoration="underline"
        _hover={{ color: 'whiteAlpha.900' }}
      >
        Open folder in Google Drive
      </Link>
    ),
    status: 'success',
    duration: 10000,
    isClosable: true,
  };
}
